import PropTypes from 'prop-types';
import { Col } from '@arkestro/arkestro-design-system';
import { ArkestroLogo } from 'components/LogoImage';

import style from './FloatingPanel.module.scss';

const DEFAULT_COL_SIZES = {
  lg: 12,
  md: 14,
  sm: 16,
  xl: 8,
  xs: 24,
};

// Use this component as a wrapper for onboarding steps
// This creates the floating white card in the middle of the page
// Use as a child within <Row gutter={16} justify='center'>
const FloatingPanel = ({ children, colSizes = DEFAULT_COL_SIZES }) => (
  <Col {...DEFAULT_COL_SIZES} {...colSizes}>
    <div className={style.border}>
      <div className={style.extra}>
        <ArkestroLogo dark />
      </div>
      <div className={style.content}>
        {children}
      </div>
    </div>
  </Col>
);

FloatingPanel.propTypes = {
  children: PropTypes.node.isRequired,
  colSizes: PropTypes.shape()
};

export default FloatingPanel;
